import obj from "@/js/obj";

let object = {
    userInfo: {},   //用户信息
    allDiscount: {},    //所有折扣信息
    allCard: {},        //所有卡项

    //初始化
    init: function () {
        this.userInfo = {};
        this.allDiscount = {};
        this.allCard = {};
    },

    /**
     * 设置会员信息
     * @param userInfo
     */
    setUserInfo: function (userInfo) {
        this.init();
        this.userInfo = userInfo;
    },

    /**
     * 清除会员信息
     */
    clearStoreUser: function () {
        this.userInfo = {};
    },

    /**
     * 计算项目金额
     * @param item
     */
    totalProPrice: function (item) {
        //计算优惠后价格
        if(item.discount_type === 1) {
            if (item.discount_data.mode == 1) {
                item.total_price = item.price * item.num * item.discount_data.data / 10;
            } else if (item.discount_data.mode == 2) {
                item.total_price = item.discount_data.data * item.num;
            } else {
                item.total_price = item.price * item.num;
            }
        }else if(item.discount_type === 2){
            let num = item.num - item.discount_data.deduct_num;
            let vipDis = this.getVipDiscount(item.pro_id, item.pro_type);
            item.total_price = item.price * num;
            if(vipDis)
                item.total_price = item.total_price * (vipDis.discount_data.discount_data / 10);

        }else{
            item.total_price = item.price * item.num;
        }
        if(typeof item.total_price === "number")
            item.total_price = item.total_price.toFixed(2);
    },

    /**
     * 更新优惠
     *
     * @param item
     * @param index
     * @returns {Promise<any>}
     */
    updateDiscount: function (item, index = null) {
        return new Promise( resolve => {
            this.getDiscount(item.pro_id, item.pro_type).then(discount => {
                if(obj.isEmpty(discount)) {
                    //无优惠时，还原默认
                    item.discount = "无";
                    item.discount_type = 0;
                    item.discount_data = {};

                    resolve();
                    return ;
                }

                //退还抵扣数量
                if(!obj.isNull(item.discount_index) && item.discount_index > -1) {
                    let deNum = item.discount_data.deduct_num;
                    let cardKey = discount[item.discount_index].card_key;
                    let surNum = cardKey ? this.allCard[cardKey].sur_num : null;
                    if(!obj.isNull(surNum) && surNum !== -1) {
                    // if(!obj.isNull(discount[item.discount_index].sur_num) && discount[item.discount_index].sur_num !== -1) {
                        // discount[item.discount_index].sur_num += deNum;
                        //
                        // let surNum = discount[item.discount_index].sur_num+"次";
                        // discount[item.discount_index].title = discount[item.discount_index].discount_data.card_type_name +" "+
                        //     discount[item.discount_index].discount_data.card_name + "(余" + surNum + ")";

                        surNum += deNum;

                        discount[item.discount_index].title = discount[item.discount_index].discount_data.card_type_name +" "+
                            discount[item.discount_index].discount_data.card_name + "(余" + surNum + "次)";
                        discount[item.discount_index].sur_num = surNum;
                        this.allCard[cardKey].sur_num = discount[item.discount_index].sur_num;

                        //更新使用相同此卡的剩余数量
                        this.updateDiscountSurNum(discount[item.discount_index].discount_data.card_no, surNum);
                    }
                }

                //优惠选择
                if(index === null && !obj.isNull(item.discount_index)) {
                    index = item.discount_index;
                }else if(index !== null){
                    item.discount_index = index;
                }

                //默认
                item.discount = "无";
                item.discount_type = 0;
                item.discount_data = {};

                //选择优惠
                let disItem = null;
                if(index === null) {
                    for (let k in discount) {
                        let val = discount[k];
                        if (val.discount_type === 1) {
                            //vip折扣
                            disItem = val;
                            item.discount_index = k;
                            break;
                        } else if (val.discount_type === 2 && val.sur_num !== 0) {
                            //抵扣
                            disItem = val;
                            item.discount_index = k;
                            break;
                        }
                    }
                }else{
                    disItem = discount[index];
                }

                if(!obj.isEmpty(disItem)) {
                    if (disItem.discount_type === 1) {
                        //vip折扣
                        item.discount_type = 1;
                        item.discount_data = {
                            mode: disItem.discount_data.discount_mode,
                            data: disItem.discount_data.discount_data
                        };

                        if(item.discount_data.mode == 1) {
                            //会员折扣
                            item.discount = item.discount_data.data + "折";
                        }else{
                            //固定价格
                            item.discount = "固定价格";
                        }

                    } else if (disItem.discount_type === 2 && disItem.sur_num !== 0) {
                        //抵扣
                        let cardKey = disItem.card_key;
                        let surNum = this.allCard[cardKey].sur_num;
                        let dn = 0;
                        if (surNum > item.num) {
                            dn = Number(item.num);
                            surNum -= dn;
                        } else if (surNum === -1) {
                            dn = Number(item.num);
                        } else {
                            dn = surNum;
                            surNum = 0;
                        }
                        disItem.sur_num = surNum;
                        this.allCard[cardKey].sur_num = surNum;

                        let surNumStr = disItem.sur_num === -1 ? "无限" : disItem.sur_num+"次";
                        disItem.title = disItem.discount_data.card_type_name +" "+ disItem.discount_data.card_name + "(余" + surNumStr + ")";
                        item.discount = "抵扣"+dn+"次";//disItem.title;
                        item.discount_type = 2;
                        item.discount_data = {
                            deduct_num: dn,
                            card_no: disItem.discount_data.card_no
                        };

                        //更新使用相同此卡的剩余数量
                        this.updateDiscountSurNum(disItem.discount_data.card_no, surNum);
                    }
                }
                resolve();
            });
        });
    },

    /**
     * 更新使用相同次卡的剩余数量
     *
     * @param cardNo
     * @param surNum
     * @returns {boolean}
     */
    updateDiscountSurNum: function (cardNo, surNum) {
        if(!cardNo || !this.allDiscount) return false;

        for (let k in this.allDiscount) {
            let disList = this.allDiscount[k];
            if(!disList) continue;

            disList.forEach((discount, k) => {
                if(discount.discount_type !== 2) return false;
                if(discount.discount_data.card_no !== cardNo) return false;

                discount.sur_num = surNum;
                let surNumStr = discount.sur_num === -1 ? "无限" : discount.sur_num+"次";
                discount.title = discount.discount_data.card_type_name +" "+ discount.discount_data.card_name + "(余" + surNumStr + ")";
            });
        }
    },

    /**
     * 获取VIP优惠
     *
     * @param proId
     * @param proType
     * @returns {*}
     */
    getVipDiscount: function (proId, proType) {
        let dk = this.userInfo.store_uid+"_"+proType+"_"+proId;
        if(!obj.isEmpty(this.allDiscount[dk])){
            for (let i in this.allDiscount[dk]) {
                if(this.allDiscount[dk][i].discount_type === 1){
                    return this.allDiscount[dk][i];
                }
            }
        } else
            return false;
    },

    /**
     * 获取折扣信息
     * @param proId
     * @param proType
     * @returns {Promise<any>}
     */
    getDiscount: function (proId, proType) {
        return new Promise(resolve => {
            if(!proType) proType = 1;
            if(obj.isEmpty(this.userInfo)) return;

            let dk = this.userInfo.store_uid+"_"+proType+"_"+proId;
            if(!obj.isEmpty(this.allDiscount[dk]))
                resolve(this.allDiscount[dk]);
            else
                this.loadDiscount(proId, proType).then(discount => {
                    if(!obj.isEmpty(discount)) {
                        discount.forEach(val => {
                            if(val.discount_type === 2) {
                                //处理次卡剩余抵扣次数
                                let cardKey = val.discount_data.card_no ? val.discount_data.card_no : dk;
                                val.card_key = cardKey;

                                if(obj.isEmpty(this.allCard[cardKey])) {
                                    let surNum = val.discount_data.max_num;
                                    let disData = {...val.discount_data};
                                    disData.sur_num = surNum;
                                    this.allCard[cardKey] = disData;

                                    val.sur_num = surNum;
                                }else{
                                    val.sur_num = this.allCard[cardKey].sur_num;
                                }
                            }
                        });
                    }
                    if(obj.isEmpty(this.allDiscount[dk]))
                        this.allDiscount[dk] = discount;

                    resolve(this.allDiscount[dk]);
                }).catch(error => {
                    // window.console.log(error);
                    resolve();
                });
        });
    },

    /**
     * 批量加载折扣
     * @param proIdArr
     * @param proType
     * @returns {Promise<any>}
     */
    loadDiscountArr: function (proIdArr, proType) {
        if(!proType) proType = 1;
        return new Promise(success => {
            let stateArr = {};
            proIdArr.forEach(id => {
                stateArr[id] = false;
                this.loadDiscount(id, proType).then(discount => {
                    stateArr[id] = true;

                    let isAllOver = true;
                    for (let i in stateArr){
                        if(!stateArr[i]){
                            isAllOver = false;
                            break;
                        }
                    }
                    if(isAllOver) success();
                });
            });
        });
    },

    /**
     * 加载优惠折扣
     * @param proId
     * @param proType
     * @returns {Promise<any>}
     */
    loadDiscount: function (proId, proType) {
        if(!proType) proType = 1;
        return new Promise((resolve, reject) => {
            if(obj.isEmpty(this.userInfo)) reject();

            let postData = {
                store_uid: this.userInfo.store_uid,
                pro_type: proType,
                pro_id: proId,
            };
            obj.postData("cash/get_product_all_discount", postData, res => {
                if (res.errcode === 0) {
                    resolve(res.data);
                }else{
                    reject(res.errdesc);
                }
            });
        });
    }
};

export default  object;
